import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoPagoService } from 'src/app/services/movimiento-pago.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { XLS_URL } from 'src/environments/environment';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import * as _ from 'lodash';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ModalViewDetailsPagoComponent } from './modal-view-details-pago/modal-view-details-pago.component';

@Component({
  selector: 'app-cartola-cliente',
  templateUrl: './cartola-cliente.component.html',
  styleUrls: ['./cartola-cliente.component.scss'],
  providers: [SecurityService],
})
export class CartolaClienteComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @Output() onClienteChange: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(ModalViewDetailsPagoComponent, { static: true }) modalVerPago: ModalViewDetailsPagoComponent;

  // Form
  formHeader: FormGroup;

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  private inputParams: any = null;
  clienteSeleccionado: any = null;
  listaRegistros: any = null;
  abonosPorAplicar: any = null;
  totales: any = null;
  paginationContext: PaginationContext = new PaginationContext();
  loading: boolean = false;
  loaded: boolean = false;
  headerData: any = {};

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private rutService: RutService,
    private clog: ConsoleService,
    private movimientoPagoService: MovimientoPagoService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('CARTOLA-CLIENTE');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.createForms();
    this.formChangesSubscriptions();
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      rut: [null, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rut')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rut: string) => {
        this.modalSeleccionarCliente.searchByRut(rut);
        this.modalSeleccionarCliente.cleanLast();
      });
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  onClienteSeleccionado({ data, origen }) {
    this.clienteSeleccionado = data;
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut);
    this.formHeader.get('rut').setValue(this.clienteSeleccionado.rutFormato);
    this.onClienteChange.emit(this.headerData.clienteSeleccionado);
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null;
    this.clearClientData();
  }
  clearClientData() {
    this.clearContent();
    this.onClienteChange.emit(null);
  }
  clearContent() {
    this.headerData = {};
    //this.formHeader.get('rut').setValue(null)
    //this.formValidatorsService.reset(this.formHeader)
  }

  validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage;
    this.buscar();
  }

  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) {
      this.validateAllFormFields(this.formHeader);
      if (!this.formHeader.valid) {
        this.toastrService.warning('Favor complete los datos requeridos');
        return;
      }

      this.paginationContext.CurrentPage = 1;
      this.listaRegistros = null;
    }

    const inputParams = {
      entidad: {
        empresa_rut: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
        cliente_proveedor_rut: this.clienteSeleccionado === null ? 0 : this.clienteSeleccionado.rut,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };

    this.loaded = false;
    this.loading = true;

    this.inputParams = inputParams;

    this.movimientoPagoService.cartolaCliente(inputParams, ({ mensajesDetalles, respuestaDetalles, mensajesTotales, respuestaTotales }) => {
      let ok = respuestaDetalles !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajesDetalles);
        this.handleSearchError();
        return;
      }

      ok = respuestaTotales !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajesTotales);
        this.handleSearchError();
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuestaDetalles;
      this.paginationContext.RecordsCount = totalRegistros;
      this.paginationContext.CurrentPage = paginaActual;
      this.paginationContext.PagesCount = totalPaginas;
      this.listaRegistros = registros;

      this.totales = respuestaTotales;

      this.GetAbonosPorAplicar();
    });
  }

  GetAbonosPorAplicar() {
    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCliente: this.sucursalEmpresa,
      rutCliente: this.clienteSeleccionado.rut,
    };

    this.queryAbonosPorAplicar(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.handleSearchError();
        return;
      }
      this.abonosPorAplicar = respuesta.saldo;
      this.loaded = true;
      this.loading = false;
    });
  }

  queryAbonosPorAplicar(inputParams, callback) {
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCliente: Decimal, $rutCliente: Decimal) {
            diferencia_pago {
              obtenerAcumuladoPagoAcuenta(filtro: { exacto: { rut_emisor: $rutEmpresa, sucursal_codigo: $sucursalCliente, cliente_proveedor_rut: $rutCliente } }) {
                mensajes {
                  tipo
                  texto
                }
                respuesta {
                  saldo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta, mensajes } = response.data.diferencia_pago.obtenerAcumuladoPagoAcuenta;
        callback({ respuesta, mensajes });
      }
    );
  }

  handleSearchError() {
    this.loaded = true;
    this.loading = false;
  }

  downloadExcel() {
    const inputParams = _.cloneDeep(this.inputParams);
    inputParams.entidad.retornaExcel = true;
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    this.movimientoPagoService.obtenerCartolaExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo);
    });
  }

  downloadPDF() {
    const inputParams = _.cloneDeep(this.inputParams);
    inputParams.entidad.retornaPDF = true;
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    this.movimientoPagoService.obtenerCartolaPDF(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo);
    });
  }

  loadAndShowDetallePago({ pago_codigo }) {
    const Usuario = this.clienteSeleccionado === null ? 0 : this.clienteSeleccionado;
    this.modalVerPago.loadAndShow(pago_codigo, Usuario);
  }
}
